export default "__VITE_ASSET__DFhT5TEL__"